/** Encode bytes as base64url (no padding). */
function toBase64Url(bytes: Uint8Array): string {
  const b64 = btoa(String.fromCharCode(...bytes))
  return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '')
}

/**
 * Generate a PKCE code_verifier and S256 code_challenge.
 *
 * verifier  — 32 random bytes base64url-encoded (43 chars, within [43, 128]).
 * challenge — base64url(SHA-256(verifier)), no padding (PKCE S256 spec).
 */
export async function createPKCE(): Promise<{
  verifier: string
  challenge: string
}> {
  const raw = new Uint8Array(32)
  crypto.getRandomValues(raw)
  const verifier = toBase64Url(raw)

  const encoded = new TextEncoder().encode(verifier)
  const hashBuf = await crypto.subtle.digest('SHA-256', encoded)
  const challenge = toBase64Url(new Uint8Array(hashBuf))

  return { verifier, challenge }
}

/**
 * Generate a random OAuth `state` parameter (base64url, no padding).
 * Uses 16 random bytes → 22-char base64url string.
 */
export function randomState(): string {
  const bytes = new Uint8Array(16)
  crypto.getRandomValues(bytes)
  return toBase64Url(bytes)
}
